var _defs, _g, _g2, _path, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutoInvestColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.304,
    height: 25.532,
    viewBox: "0 0 24.304 25.532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .autoInvestColored1,.autoInvestColored2{fill:none}.autoInvestColored2{stroke:#8c8d99}.autoInvestColored1,.autoInvestColored2{stroke-linecap:round;stroke-width:1.5px}.autoInvestColored1{stroke-linejoin:round;stroke:#1bc47d}.autoInvestColored2{stroke-miterlimit:10}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20745",
    "data-name": "Group 20745",
    transform: "translate(-293.696 -361.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20584",
    "data-name": "Group 20584",
    transform: "translate(294 362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_chart",
    "data-name": "vuesax/linear/chart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.324 0H0",
    transform: "translate(9.048 22)",
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: "1.5px",
      stroke: "#8c8d99",
      fill: "none"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20735",
    "data-name": "Group 20735",
    transform: "translate(.446 16.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    className: "autoInvestColored1",
    d: "M0 0h5.34A1.161 1.161 0 0 1 6.5 1.16v1.28",
    transform: "translate(0 1.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    className: "autoInvestColored1",
    d: "M1.22 0 0 1.22l1.22 1.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    className: "autoInvestColored1",
    d: "M6.5 2.44H1.16A1.161 1.161 0 0 1 0 1.28V0",
    transform: "translate(0 4.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    className: "autoInvestColored1",
    d: "m0 2.44 1.22-1.22L0 0",
    transform: "translate(5.281 5.28)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_20743",
    "data-name": "Group 20743"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9724",
    "data-name": "Path 9724",
    className: "autoInvestColored2",
    d: "M2.973 2.275V13.8a1.292 1.292 0 0 0 1.245 1.334h1.133A1.292 1.292 0 0 0 6.6 13.8V2.327",
    transform: "translate(301.216 365.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9723",
    "data-name": "Path 9723",
    className: "autoInvestColored2",
    d: "M2.973 16.753v-6.734c0-.913.558-1.652 1.245-1.652h1.133c.687 0 1.245.739 1.245 1.652v6.668",
    transform: "translate(301.216 357.587)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9727",
    "data-name": "Path 9727",
    className: "autoInvestColored2",
    d: "M2.973 15.317v-5.3c0-.913.558-1.652 1.245-1.652h1.133c.687 0 1.245.739 1.245 1.652v5.233",
    transform: "translate(293.666 360.587)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_20744",
    "data-name": "Group 20744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9725",
    "data-name": "Path 9725",
    className: "autoInvestColored2",
    d: "M2.973 2.275V13.8a1.292 1.292 0 0 0 1.245 1.334h1.133A1.292 1.292 0 0 0 6.6 13.8V2.327",
    transform: "translate(308.766 365.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9726",
    "data-name": "Path 9726",
    className: "autoInvestColored2",
    d: "M2.973 16.753v-6.734c0-.913.558-1.652 1.245-1.652h1.133c.687 0 1.245.739 1.245 1.652v6.668",
    transform: "translate(308.766 353.633)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoInvestColored);
export default __webpack_public_path__ + "static/media/auto-invest-colored.9d6da3aa4c48afc7311714bfbc0157b2.svg";
export { ForwardRef as ReactComponent };